var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.39 13.883q.707.001 1.094-.57L14.797 2.03c.187-.281.265-.539.265-.781 0-.64-.468-1.102-1.124-1.102-.454 0-.727.157-1 .594L6.359 11.148 3 6.914c-.266-.32-.54-.469-.93-.469-.664 0-1.14.47-1.14 1.117 0 .282.093.547.336.829l4.039 4.96c.304.368.64.532 1.086.532"
  })));
};
export default SvgCheck;